const apiURL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:3001'

export default apiURL
